/* eslint-disable generator-star-spacing */
import { Map, List } from "immutable"

import * as bookingsApi from "mmb/services/bookings/bookingsApi"
import { listWatchdogs } from "./watchdogApi"
import mapperWatchdog from "./mapperWatchdog"

export async function loadWatchdogs(lang, locale) {
  /*
   * watchdog = {
   *   id: number,
   *   active: number, // 0 - inactive, 1 - active
   *   created: number, // timestamp
   *   search_form_json: JSON, // see WatchdogSearch in containers/Watchdog
   * }
   *
   * data = {
   *   lang: string,
   *   watchdogs: Array<watchdog>,
   *   translations: {
   *     [city_id]: {
   *       country_name: string,
   *       geo_name: string,
   *     },
   *   },
   * }
   */
  const data = await listWatchdogs(lang, locale)

  return data.watchdogs
    .reduce((map, dog) => map.set(dog.id, mapperWatchdog(dog, data.translations)), new Map())
    .sort((a, b) => (a.created < b.created ? 1 : -1))
}

export async function loadTransactions(filters) {
  const transactions = await bookingsApi.findTransactions(filters)

  return new List(transactions)
}

export async function loadBookings(locale, filters) {
  const bookings = await bookingsApi.find(locale, filters)

  return new List(bookings)
}
